<campaign-sms-configuration-alert></campaign-sms-configuration-alert>
<va-filtered-mat-table
  [tableDataService]="myCampaignsTableService"
  [limitContentHeightForDesktop]="false"
  class="my-campaigns-table"
  (cellEventEmitter)="reloadTable()"
></va-filtered-mat-table>
